// extracted by mini-css-extract-plugin
module.exports = {"select-boxes":"Filters_select-boxes__2ZsXO"};